import { Typography } from '@saesa/ui-kit-front';

const Redireccion = ({
  className,
  texto,
  variant,
  link,
}: {
  className: string;
  texto: string;
  variant: 'emphasis' | 'h1' | 'h2' | 'h3' | 'parrafo' | 'label' | 'labelSmall';
  link: string;
}) => (
  <button
    className={`link_boton ${className}`}
    onClick={() => {
      window.location.assign(link);
    }}
    type="button"
    data-testid="boton-mostrar-boleta"
  >
    <Typography variant={variant}>{texto}</Typography>
  </button>
);

export default Redireccion;
